import React from "react";

const ViewPaidOrders = () => {
  return <div></div>;
};

export default ViewPaidOrders;
